// ==========================================
// MONARCH DETAILING - DATA CONSTANTS
// ==========================================

// ==========================================
// RAFFLE — All Aboard CDC lead-gen test
// ==========================================
export const RAFFLE_OPEN_AT = new Date(2026, 8, 9, 0, 0, 0);   // Wednesday, Sept 9, 2026
export const RAFFLE_CLOSE_AT = new Date(2026, 8, 18, 18, 0, 0); // Friday, Sept 18, 2026, 6:00pm ET
export const RAFFLE_DRAW_DATE_LABEL = 'Friday, September 18, 2026';

export const carMakes = [
  'Acura', 'Alfa Romeo', 'Audi', 'BMW', 'Buick', 'Cadillac', 'Chevrolet', 'Chrysler',
  'Dodge', 'Ford', 'Genesis', 'GMC', 'Honda', 'Hyundai', 'Infiniti',
  'Jaguar', 'Jeep', 'Kia', 'Land Rover', 'Lexus', 'Lincoln', 'Mazda', 'Mercedes-Benz',
  'MINI', 'Mitsubishi', 'Nissan', 'Polestar', 'Porsche',
  'Ram', 'Rivian', 'Subaru', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo'
];

export const carModels = {
  'Acura': ['ILX', 'TLX', 'MDX', 'RDX', 'NSX'],
  'Alfa Romeo': ['Giulia', 'Stelvio'],
  'Audi': ['A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'Q3', 'Q5', 'Q7', 'Q8', 'e-tron'],
  'BMW': ['2 Series', '3 Series', '4 Series', '5 Series', '7 Series', 'X1', 'X3', 'X5', 'X7', 'i3', 'i4', 'i7', 'iX'],
  'Buick': ['Encore', 'Encore GX', 'Envision', 'Enclave'],
  'Cadillac': ['CT4', 'CT5', 'XT4', 'XT5', 'XT6', 'Escalade', 'LYRIQ'],
  'Chevrolet': ['Spark', 'Malibu', 'Camaro', 'Corvette', 'Bolt EV', 'Bolt EUV', 'Trax', 'Equinox', 'Blazer', 'Traverse', 'Tahoe', 'Suburban', 'Silverado'],
  'Chrysler': ['300', 'Pacifica'],
  'Dodge': ['Charger', 'Challenger', 'Durango', 'Hornet'],
  'Ford': ['Fiesta', 'Focus', 'Fusion', 'Mustang', 'Mustang Mach-E', 'EcoSport', 'Escape', 'Edge', 'Explorer', 'Expedition', 'F-150', 'Bronco', 'Maverick'],
  'Genesis': ['G70', 'G80', 'G90', 'GV60', 'GV70', 'GV80'],
  'GMC': ['Terrain', 'Acadia', 'Yukon', 'Sierra'],
  'Honda': ['Civic', 'Accord', 'Insight', 'HR-V', 'CR-V', 'Passport', 'Pilot', 'Odyssey', 'Ridgeline', 'Element'],
  'Hyundai': ['Accent', 'Elantra', 'Sonata', 'Venue', 'Kona', 'Tucson', 'Santa Fe', 'Palisade', 'Ioniq 5', 'Ioniq 6'],
  'Infiniti': ['Q50', 'Q60', 'QX50', 'QX55', 'QX60', 'QX80'],
  'Jaguar': ['XE', 'XF', 'F-Pace', 'E-Pace', 'I-Pace'],
  'Jeep': ['Renegade', 'Compass', 'Cherokee', 'Grand Cherokee', 'Wrangler', 'Gladiator', 'Wagoneer', 'Grand Wagoneer'],
  'Kia': ['Rio', 'Forte', 'K5', 'Stinger', 'Niro', 'Soul', 'Seltos', 'Sportage', 'Sorento', 'Telluride', 'EV6', 'EV9'],
  'Land Rover': ['Range Rover', 'Range Rover Sport', 'Range Rover Velar', 'Defender', 'Discovery'],
  'Lexus': ['IS', 'ES', 'LS', 'UX', 'NX', 'RX', 'GX', 'LX', 'RZ'],
  'Lincoln': ['Corsair', 'Nautilus', 'Aviator', 'Navigator'],
  'Mazda': ['Mazda3', 'Mazda6', 'CX-30', 'CX-5', 'CX-50', 'CX-9', 'MX-5 Miata'],
  'Mercedes-Benz': ['A-Class', 'C-Class', 'E-Class', 'S-Class', 'GLA', 'GLB', 'GLC', 'GLE', 'GLS', 'EQS'],
  'MINI': ['Cooper', 'Countryman', 'Clubman', 'Paceman'],
  'Mitsubishi': ['Mirage', 'Galant', 'Eclipse Cross', 'Outlander Sport', 'Outlander'],
  'Nissan': ['Versa', 'Sentra', 'Altima', 'Maxima', 'Leaf', 'Kicks', 'Rogue', 'Murano', 'Pathfinder', 'Armada', 'Frontier', 'Titan', 'Ariya'],
  'Polestar': ['2', '3', '4'],
  'Porsche': ['911', 'Macan', 'Cayenne', 'Panamera', 'Taycan'],
  'Ram': ['1500', '2500', '3500'],
  'Rivian': ['R1T', 'R1S'],
  'Subaru': ['Impreza', 'Legacy', 'Crosstrek', 'Outback', 'Forester', 'Ascent', 'Solterra'],
  'Tesla': ['Model 3', 'Model S', 'Model X', 'Model Y'],
  'Toyota': ['Corolla', 'Camry', 'Avalon', 'Prius', 'C-HR', 'RAV4', 'Venza', 'Sienna', 'Highlander', 'Sequoia', '4Runner', 'Land Cruiser', 'Tacoma', 'Tundra', 'bZ4X'],
  'Volkswagen': ['Jetta', 'Passat', 'Arteon', 'Taos', 'Tiguan', 'Atlas', 'ID.4'],
  'Volvo': ['S60', 'S90', 'V60', 'V90', 'XC40', 'XC60', 'XC90', 'C40']
};

export const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
export const weeks = ['Week 1', 'Week 2', 'Week 3', 'Week 4'];

export const currentYear = 2026;
export const years = Array.from({ length: currentYear - 1989 }, (_, i) => currentYear - i);

// Firestore availability document IDs map
// Converts "Week 1" + "Monday" → "week_1_monday"
export const getSlotId = (week, day) => {
  const weekNum = week.replace('Week ', '');
  return `week_${weekNum}_${day.toLowerCase()}`;
};

// Converts "week_1_monday" → "Week 1 - Monday"
export const getSlotLabel = (slotId) => {
  const parts = slotId.split('_');
  const weekNum = parts[1];
  const day = parts[2].charAt(0).toUpperCase() + parts[2].slice(1);
  return `Week ${weekNum} - ${day}`;
};

// ==========================================
// PHASE 2 — WEEKEND BOOKING (3 Tiers — disabled for interiors-only launch)
// ==========================================
/* PHASE 2 START
export const WEEKEND_TIERS = {
  1: {
    id: 1,
    name: 'Tier 1',
    price: 99,
    priceCents: 9900,
    tagline: 'Caterpillar',
    features: [
      'Standard exterior hand wash & dry',
      'Tire, rim & wheel well cleaning with tire shine',
      'Basic interior vacuum & wipe down',
      'All windows cleaned streak-free',
    ],
    highlight: false,
    customQuote: false,
  },
  2: {
    id: 2,
    name: 'Tier 2',
    price: 149,
    priceCents: 14900,
    tagline: 'Butterfly',
    features: [
      'Everything in Caterpillar',
      'Interior steam cleaning',
      'Door & trunk jamb cleaning',
      'Light stain removal',
      'Interior plastic trim dressing & leather conditioning',
    ],
    highlight: true,
    customQuote: false,
  },
  3: {
    id: 3,
    name: 'Tier 3',
    price: 250,
    priceCents: 25000,
    tagline: 'The Alchemist',
    features: [
      'Everything in Butterfly',
      'Full paint decontamination & clay towel treatment',
      'Sealant application for lasting paint protection',
      'Complete odor elimination & deep sanitization',
    ],
    highlight: false,
    customQuote: false,
  },
};
PHASE 2 END */

// ==========================================
// PHASE 2 — WEEKEND CALENDAR HELPERS (disabled for interiors-only launch)
// ==========================================

/* PHASE 2 START
// Generates upcoming Sat + Sun pairs for the next N weeks
export const getUpcomingWeekends = (weeksAhead = 8) => {
  const dates = [];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dayOfWeek = today.getDay(); // 0=Sun, 6=Sat
  const daysUntilNextSat = dayOfWeek === 6 ? 7 : (6 - dayOfWeek);
  const nextSat = new Date(today);
  nextSat.setDate(today.getDate() + daysUntilNextSat);
  for (let week = 0; week < weeksAhead; week++) {
    const sat = new Date(nextSat);
    sat.setDate(nextSat.getDate() + week * 7);
    const sun = new Date(sat);
    sun.setDate(sat.getDate() + 1);
    dates.push(sat, sun);
  }
  return dates;
};

export const formatWeekendDateId = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const getWeekendSlotId = (date, timeSlotId) =>
  `${formatWeekendDateId(date)}_${timeSlotId}`;

export const formatWeekendSlotLabel = (slotId) => {
  if (!slotId) return '';
  const [datePart, timePart] = slotId.split('_');
  const [year, month, day] = datePart.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  const dateStr = date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
  const timeStr = timePart === 'morning' ? '9:00 AM' : '1:00 PM';
  return `${dateStr} at ${timeStr}`;
};

export const WEEKEND_TIME_SLOTS = [
  { id: 'morning', label: 'Morning', time: '9:00 AM' },
  { id: 'afternoon', label: 'Afternoon', time: '1:00 PM' },
];
PHASE 2 END */

// ==========================================
// MAINTENANCE PREDICTIVE SCHEDULING
// ==========================================

const DAY_INDEX = {
  sunday: 0, monday: 1, tuesday: 2, wednesday: 3,
  thursday: 4, friday: 5, saturday: 6,
};

// Returns the Nth occurrence of a weekday in a given month.
// weekNum: 1-4, dayName: 'monday', 'tuesday', etc.
// Returns null if that Nth day doesn't exist in the month.
export const getNthWeekdayOfMonth = (year, month, weekNum, dayName) => {
  const targetDay = DAY_INDEX[dayName.toLowerCase()];
  if (targetDay === undefined) return null;
  const firstOfMonth = new Date(year, month, 1);
  const firstDow = firstOfMonth.getDay();
  let daysToTarget = targetDay - firstDow;
  if (daysToTarget < 0) daysToTarget += 7;
  const date = new Date(year, month, 1 + daysToTarget + (weekNum - 1) * 7, 9, 0, 0);
  if (date.getMonth() !== month) return null; // e.g. "5th Friday" that doesn't exist
  return date;
};

// ==========================================
// MAINTENANCE PROGRAM — PRICING & ADD-ONS
// ==========================================

export const MAINTENANCE_VEHICLE_TYPES = [
  { id: 'sedan', label: 'Sedan / Coupe',          resetPrice: 200, monthlyPrice: 75, icon: '🚗' },
  { id: 'suv',   label: 'SUV / Crossover',         resetPrice: 215, monthlyPrice: 80, icon: '🚙' },
  { id: 'truck', label: 'Truck / Full-Size / Van', resetPrice: 225, monthlyPrice: 85, icon: '🛻' },
];

export const MAINTENANCE_PRICING = {
  reset:   { sedan: 200, suv: 215, truck: 225 },
  monthly: { sedan: 75,  suv: 80,  truck: 85  },
};

// Situation charges — same add-ons as the booking flow, same prices.
// Applied by Akeem when a maintenance visit requires something beyond the flat rate scope.
// Communicated to the client before work begins.
export const SITUATION_CHARGES = [
  { id: 'carpet_shampoo', label: 'Carpet & Seat Deep Shampoo', price: 50, emoji: '💧', desc: 'Deep machine shampoo of all carpet, floor mats & fabric seats — removes embedded dirt and set-in grime' },
  { id: 'heavy_stain',    label: 'Heavy Stain Treatment',       price: 25, emoji: '🧹', desc: 'Targeted spot treatment for tough, set-in stains on seats or carpet — $25 per spot' },
  { id: 'pet_hair',       label: 'Pet Hair Removal',            price: 45, emoji: '🐾', desc: 'Specialized tools to pull embedded pet hair from seats, carpet & tight spots a vacuum can\'t reach' },
  { id: 'odor_removal',   label: 'Odor Elimination',            price: 75, emoji: '🌬️', desc: 'Bio-bomb treatment neutralizes odors at the source — smoke, mildew, pets, food & more. Not a cover-up.' },
  { id: 'car_seat',       label: 'Car Seat Deep Clean',         price: 35, emoji: '👶', desc: 'Full deep clean of child car seat(s) — fabric, buckles, straps & foam sanitized' },
];

// Canonical add-on list — identical across all booking types
export const ADD_ONS = [
  {
    id: 'steam_clean',
    label: 'Steam Treatment',
    price: 35,
    priceCents: 3500,
    emoji: '💨',
    icon: '💨',
    color: 'from-slate-50 to-gray-50',
    border: 'border-slate-200',
    desc: 'High-heat steam sanitizes seats, carpet, vents & door panels — kills bacteria, mold & allergens at the source',
  },
  {
    id: 'carpet_shampoo',
    label: 'Carpet & Seat Deep Shampoo',
    price: 50,
    priceCents: 5000,
    emoji: '💧',
    icon: '💧',
    color: 'from-blue-50 to-cyan-50',
    border: 'border-blue-200',
    desc: 'Deep machine shampoo of all carpet, floor mats & fabric seats — removes embedded dirt and set-in grime',
  },
  {
    id: 'heavy_stain',
    label: 'Heavy Stain Treatment',
    price: 25,
    priceCents: 2500,
    emoji: '🧹',
    icon: '🧹',
    color: 'from-orange-50 to-amber-50',
    border: 'border-orange-200',
    desc: 'Targeted treatment for tough, set-in stains on seats or carpet that go beyond a standard clean',
  },
  {
    id: 'pet_hair',
    label: 'Pet Hair Removal',
    price: 45,
    priceCents: 4500,
    emoji: '🐾',
    icon: '🐾',
    color: 'from-green-50 to-emerald-50',
    border: 'border-green-200',
    desc: 'Specialized tools to pull embedded pet hair from seats, carpet & tight spots a vacuum can\'t reach',
  },
  {
    id: 'odor_removal',
    label: 'Odor Elimination',
    price: 75,
    priceCents: 7500,
    emoji: '🌬️',
    icon: '🌬️',
    color: 'from-sky-50 to-blue-50',
    border: 'border-sky-200',
    desc: 'Bio-bomb treatment neutralizes odors at the source — smoke, mildew, pets, food & more. Not a cover-up.',
  },
  {
    id: 'car_seat',
    label: 'Car Seat Deep Clean',
    price: 35,
    priceCents: 3500,
    emoji: '👶',
    icon: '👶',
    color: 'from-purple-50 to-violet-50',
    border: 'border-purple-200',
    desc: 'Full deep clean of child car seat(s) — fabric, buckles, straps & foam sanitized',
  },
];

export const MAINTENANCE_ADD_ONS = ADD_ONS;
export const RESET_ADD_ONS = ADD_ONS;

const PICKUP_TRUCK_MODELS = new Set([
  'F-150', 'F-250', 'F-350', 'F-450', 'Maverick', 'Ranger',
  'Silverado', 'Colorado',
  'Sierra', 'Canyon',
  '1500', '2500', '3500',
  'Tacoma', 'Tundra',
  'Frontier', 'Titan',
  'Ridgeline',
  'Gladiator',
  'Ram 1500', 'Ram 2500', 'Ram 3500', 'Dakota',
  'R1T',
]);

const SUV_TRUCK_MODELS = new Set([
  'MDX', 'RDX',
  'Stelvio',
  'Q3', 'Q5', 'Q7', 'Q8', 'e-tron',
  'X1', 'X3', 'X5', 'X7', 'iX',
  'Encore', 'Encore GX', 'Envision', 'Enclave',
  'XT4', 'XT5', 'XT6', 'Escalade', 'LYRIQ',
  'Bolt EUV', 'Trax', 'Equinox', 'Blazer', 'Traverse', 'Tahoe', 'Suburban', 'Silverado',
  'Pacifica',
  'Durango', 'Hornet',
  'Mustang Mach-E', 'EcoSport', 'Escape', 'Edge', 'Explorer', 'Expedition', 'F-150', 'Bronco', 'Maverick',
  'GV60', 'GV70', 'GV80',
  'Terrain', 'Acadia', 'Yukon', 'Sierra',
  'HR-V', 'CR-V', 'Passport', 'Pilot', 'Odyssey', 'Ridgeline',
  'Venue', 'Kona', 'Tucson', 'Santa Fe', 'Palisade', 'Ioniq 5',
  'F-Pace', 'E-Pace',
  'QX50', 'QX55', 'QX60', 'QX80',
  'Renegade', 'Compass', 'Cherokee', 'Grand Cherokee', 'Wrangler', 'Gladiator', 'Wagoneer', 'Grand Wagoneer',
  'Niro', 'Soul', 'Seltos', 'Sportage', 'Sorento', 'Telluride', 'EV9',
  'Range Rover', 'Range Rover Sport', 'Range Rover Velar', 'Defender', 'Discovery',
  'UX', 'NX', 'RX', 'GX', 'LX', 'RZ',
  'Corsair', 'Nautilus', 'Aviator', 'Navigator',
  'CX-30', 'CX-5', 'CX-50', 'CX-9',
  'GLA', 'GLB', 'GLC', 'GLE', 'GLS',
  'Countryman', 'Paceman',
  'Eclipse Cross', 'Outlander Sport', 'Outlander',
  'Kicks', 'Rogue', 'Murano', 'Pathfinder', 'Armada', 'Frontier', 'Titan', 'Ariya',
  'Cayenne', 'Macan',
  '1500', '2500', '3500',
  'R1T', 'R1S',
  'Crosstrek', 'Outback', 'Forester', 'Ascent', 'Solterra',
  'Model X', 'Model Y',
  'C-HR', 'RAV4', 'Venza', 'Sienna', 'Highlander', 'Sequoia', '4Runner', 'Land Cruiser', 'Tacoma', 'Tundra',
  'Taos', 'Tiguan', 'Atlas', 'ID.4',
  'XC40', 'XC60', 'XC90',
  'CX-90', 'Grand Cherokee L',
]);

// Vehicles that come standard (or near-standard) with a third row of
// seating. These price at the truck tier ($150), same as full-size
// pickups and vans — more seats/rows means more interior to detail.
const THREE_ROW_MODELS = new Set([
  'Pathfinder', 'Armada',
  'Highlander', 'Sequoia', 'Sienna', 'Land Cruiser',
  'Pilot', 'Odyssey',
  'Traverse', 'Tahoe', 'Suburban',
  'Acadia', 'Yukon',
  'Enclave',
  'Escalade',
  'Explorer', 'Expedition',
  'Durango',
  'Pacifica',
  'Telluride', 'Sorento', 'EV9',
  'Palisade',
  'Atlas',
  'Ascent',
  'CX-9', 'CX-90',
  'QX60', 'QX80',
  'MDX',
  'Q7',
  'X7',
  'GLS',
  'Discovery',
  'XC90',
  'Aviator', 'Navigator',
  'Wagoneer', 'Grand Wagoneer', 'Grand Cherokee L',
]);

export const isSuvOrTruck = (_make, model) => SUV_TRUCK_MODELS.has(model);

// Auto-detect vehicle tier from make + model. Returns 'sedan' | 'suv' | 'truck' | null
export const detectVehicleType = (_make, model) => {
  if (!model) return null;
  if (PICKUP_TRUCK_MODELS.has(model)) return 'truck';
  if (THREE_ROW_MODELS.has(model)) return 'truck';
  if (SUV_TRUCK_MODELS.has(model)) return 'suv';
  return null;
};

// Returns an array of upcoming appointment Dates for a given slotId.
// slotId: "week_2_tuesday", monthsAhead: how many months forward to generate.
// Convert any UTC date to display correctly in America/New_York (ET)
export const toET = (date) => {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;
  return new Date(d.toLocaleString('en-US', { timeZone: 'America/New_York' }));
};

export const getSlotDates = (slotId, monthsAhead = 6) => {
  if (!slotId) return [];
  const parts = slotId.split('_');
  if (parts.length < 3) return [];
  const weekNum = parseInt(parts[1], 10);
  const dayName = parts[2];
  if (isNaN(weekNum) || weekNum < 1 || weekNum > 4) return [];
  const now = new Date();
  const dates = [];
  for (let i = 0; i < monthsAhead; i++) {
    const y = now.getFullYear();
    const m = now.getMonth() + i;
    const year = y + Math.floor(m / 12);
    const month = m % 12;
    const date = getNthWeekdayOfMonth(year, month, weekNum, dayName);
    if (date && date >= now) dates.push(date);
  }
  return dates;
};

// ==========================================
// ONE-TIME DETAIL — PACKAGES & CALENDAR
// ==========================================

// Three one-time INTERIOR packages: Average (Maintenance) / Advanced / The Alchemist.
// Pricing is vehicle-type-based (see INTERIOR_VEHICLE_TYPES below for the
// Interior Detail tiers; each package carries its own sedan/SUV/truck prices).
// Package pricing is applied at checkout via the vehicleType param.
export const ONE_TIME_PACKAGES = [
  {
    id: 'maintenance_refresh',
    name: 'Average',
    price: 75,
    suvPrice: 80,
    truckPrice: 85,
    priceCents: 7500,
    suvPriceCents: 8000,
    truckPriceCents: 8500,
    emoji: '🧼',
    tagline: 'Maintenance Clean — vacuum, wipe-down & windows only',
    features: [
      'Vacuum — seats, carpet & floor mats',
      'Dashboard, door panels & console wipe-down',
      'All interior windows cleaned streak-free',
    ],
    notIncluded: [
      'No stain treatment',
      'No shampoo or steam',
      'No pet hair or odor removal',
    ],
    highlight: false,
  },
  {
    id: 'interior',
    name: 'Advanced',
    price: 120,
    suvPrice: 135,
    truckPrice: 150,
    priceCents: 12000,
    suvPriceCents: 13500,
    truckPriceCents: 15000,
    emoji: '👑',
    tagline: 'Our regular Interior Detail — the full clean',
    features: [
      'Full vacuum — seats, carpet, floor mats & trunk',
      'Dashboard, door panels & console wipe-down',
      'Cracks, crevices & cup holder cleaning',
      'Light surface stain treatment',
      'All interior windows cleaned streak-free',
      'UV protectant on dash & plastics',
      'Door & trunk jamb wipe-down',
    ],
    notIncluded: [
      'No deep shampoo or steam (see The Alchemist)',
      'No heavy / set-in stain removal',
      'No pet hair or odor removal',
    ],
    highlight: true,
  },
  {
    id: 'alchemist',
    name: 'The Alchemist',
    price: 200,
    suvPrice: 215,
    truckPrice: 225,
    priceCents: 20000,
    suvPriceCents: 21500,
    truckPriceCents: 22500,
    emoji: '🦋',
    tagline: 'Advanced + steam & deep shampoo included',
    features: [
      'Everything in Advanced',
      'Steam Treatment included',
      'Carpet & Seat Deep Shampoo included',
    ],
    notIncluded: [
      'Pet hair, odor, heavy stain & car seat cleaning are add-ons',
    ],
    highlight: false,
  },
  // DEV TEST — hidden $1 package, accessible only via direct URL. Not shown publicly.
  {
    id: 'dev_test',
    name: 'Test Booking (Dev)',
    price: 1,
    suvPrice: 1,
    truckPrice: 1,
    priceCents: 100,
    suvPriceCents: 100,
    truckPriceCents: 100,
    emoji: '🧪',
    tagline: 'Internal test only — $0.50 deposit',
    features: ['Full flow test'],
    highlight: false,
  },

  /* PHASE 2 START — exterior and full-detail packages
  {
    id: 'exterior',
    name: 'Exterior Detail',
    price: 130,
    priceCents: 13000,
    emoji: '✨',
    tagline: 'Exterior only — full paint treatment outside',
    features: [
      'Hand wash & dry',
      'Wheel, rim & wheel well cleaning with tire shine',
      'Clay towel paint decontamination',
      'Spray wax / sealant application',
      'All exterior windows streak-free',
    ],
    highlight: false,
  },
  {
    id: 'basic_full',
    name: 'Basic Full Detail',
    price: 185,
    priceCents: 18500,
    emoji: '🚗',
    tagline: 'Interior + exterior wash — no clay or wax',
    features: [
      'Full interior vacuum & steam clean',
      'Exterior hand wash & dry',
      'Wheel & tire cleaning',
      'Windows inside & out',
    ],
    highlight: false,
  },
  {
    id: 'full',
    name: 'Full Detail',
    price: 250,
    priceCents: 25000,
    emoji: '🦋',
    tagline: 'Complete inside & out with clay + wax',
    features: [
      'Everything in Interior Detail',
      'Everything in Exterior Detail',
      'Clay towel treatment + spray wax included',
    ],
    highlight: true,
  },
  {
    id: 'monarch',
    name: 'Monarch Detail',
    price: 325,
    priceCents: 32500,
    emoji: '👑',
    tagline: 'Our signature experience — the full transformation',
    features: [
      'Everything in Full Detail',
      'Full paint decontamination treatment',
      'Ceramic sealant (exclusive to this package)',
      'Complete odor elimination & deep sanitization',
      'The Monarch signature finish',
    ],
    highlight: false,
  },
  PHASE 2 END */
];

// ==========================================
// PHASE 1 LAUNCH — INTERIOR BOOKING CONSTANTS
// ==========================================

export const INTERIOR_VEHICLE_TYPES = [
  { id: 'sedan', label: 'Sedan / Coupe',           desc: 'Cars, coupes, sports cars, compact cars', price: 120, icon: '🚗' },
  { id: 'suv',   label: 'SUV / Crossover',          desc: 'Midsize and full-size crossovers, SUVs', price: 135, icon: '🚙' },
  { id: 'truck', label: 'Truck / Full-Size / Van',  desc: 'Full-size pickups, large SUVs, minivans', price: 150, icon: '🛻' },
];

export const INTERIOR_ADD_ONS = ADD_ONS;

export const INTERIOR_BASE_INCLUDES = [
  'Full vacuum — seats, carpet, floor mats & trunk',
  'Dashboard, console & door panel wipe-down',
  'Cracks, crevices & cup holder cleaning',
  'Light surface stain treatment',
  'All interior windows cleaned streak-free',
  'Door & trunk jamb wipe-down',
  'Headliner spot clean',
  'UV protectant on dash & plastics',
  'Final walk-through before handoff',
];

// Weekday (Mon–Fri) time slots
export const ONE_TIME_WEEKDAY_SLOTS = [
  { id: '9am', label: 'Morning', time: '9:00 AM' },
];

// Saturday time slots
export const ONE_TIME_SATURDAY_SLOTS = [
  { id: '9am', label: 'Morning', time: '9:00 AM' },
];

// One car per day: Akeem works alone (and has another job at 2 PM), so a day is
// FULL as soon as anything is booked on it — in either the one-time or the
// Reset (maintenance) calendar. Takes the booked slot ids and returns a map
// that also marks every current slot of those days as taken, so older slot ids
// (e.g. a past '..._11am') still block the day. Mirrors isBookingDayTaken() in
// api/_utils.js.
export const markBookedDays = (slotIds) => {
  const taken = {};
  const slots = [...ONE_TIME_WEEKDAY_SLOTS, ...ONE_TIME_SATURDAY_SLOTS];
  (slotIds || []).forEach((id) => {
    if (!id) return;
    taken[id] = true;
    const day = String(id).slice(0, 10);
    slots.forEach((s) => { taken[`${day}_${s.id}`] = true; });
  });
  return taken;
};

// Same-day / emergency / second-car-on-a-booked-day jobs are arranged by text
// and booked by Akeem in the admin wizard, with this flat fee added.
export const RUSH_FEE = 40;
export const SHOP_PHONE_SMS = '+13018859767';

// Hard floor: no bookings before August 3, 2026 (launch date)
export const BOOKING_LAUNCH_DATE = new Date(2026, 7, 3);

// Returns Mon–Sat dates in a rolling window starting from launch date or minDaysAhead, whichever is later
export const getOneTimeDates = (minDaysAhead = 0, windowDays = 60) => {
  const dates = [];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const earliest = new Date(today);
  earliest.setDate(today.getDate() + minDaysAhead);
  const launchFloor = new Date(BOOKING_LAUNCH_DATE);
  launchFloor.setHours(0, 0, 0, 0);
  const start = earliest < launchFloor ? launchFloor : earliest;
  const end = new Date(start);
  end.setDate(start.getDate() + windowDays);
  const curr = new Date(start);
  while (curr <= end) {
    if (curr.getDay() !== 0) dates.push(new Date(curr)); // Mon–Sat, exclude Sunday only
    curr.setDate(curr.getDate() + 1);
  }
  return dates;
};

export const formatOnetimeDateId = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

// Current promo window (MONARCH15, FB10, SEAT50, /promo countdown) — one place to
// extend it. Ends Sat Nov 14, 2026, 11:59:59 PM ET (extended from Nov 7) (EST, UTC-5, after the Nov 1 clock
// change). Keep in sync with PROMO_EXPIRY_MS in api/_utils.js (server-side).
// Ad offer: 15% off any package for the first 10 bookings (cap enforced
// server-side — see LAUNCH_PROMO_* in api/_utils.js; keep these in sync).
export const LAUNCH_PROMO_CODE = 'MONARCH15';
export const LAUNCH_PROMO_RATE = 0.15;
export const LAUNCH_PROMO_CAP = 10;
export const FALLBACK_PROMO_CODE = 'FB10';
export const FALLBACK_PROMO_RATE = 0.10;

export const PROMO_EXPIRY_ISO = '2026-11-14T23:59:59-05:00';
export const PROMO_EXPIRY_LABEL = 'November 14, 2026';
export const PROMO_EXPIRY_SHORT = 'Nov 14';
// Exact wording used on /promo and in the ads — keep word-for-word identical.
export const PROMO_EXPIRY_DISPLAY = 'Nov 14, 2026 11:59 PM ET';

// SEAT50 (car seat special): 50% off the car seat add-on. Independent of the
// package promo and stackable with MONARCH15 / FB10. Same end date as them.
export const SEAT_PROMO_CODE = 'SEAT50';
export const SEAT_PROMO_RATE = 0.5;

// Dates the shop is closed — not bookable in any booking flow.
// Keep in sync with CLOSED_BOOKING_DATES in api/_utils.js (server-side guard).
export const CLOSED_BOOKING_DATES = ['2026-10-26', '2026-10-27', '2026-10-28', '2026-10-30'];

export const isClosedBookingDate = (date) => CLOSED_BOOKING_DATES.includes(formatOnetimeDateId(date));

export const getOnetimeSlotId = (date, timeSlotId) =>
  `${formatOnetimeDateId(date)}_${timeSlotId}`;

const ONE_TIME_TIME_LABELS = {
  '9am': '9:00 AM', '11am': '11:00 AM',
  '1pm': '1:00 PM', '3pm': '3:00 PM', '5pm': '5:00 PM',
};

export const formatOnetimeSlotLabel = (slotId) => {
  if (!slotId) return '';
  const [datePart, timePart] = slotId.split('_');
  const [year, month, day] = datePart.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  const dateStr = date.toLocaleDateString('en-US', {
    weekday: 'long', month: 'long', day: 'numeric',
  });
  return `${dateStr} at ${ONE_TIME_TIME_LABELS[timePart] || timePart}`;
};
